import { render, staticRenderFns } from "./new_more.vue?vue&type=template&id=48921dda&"
import script from "./new_more.vue?vue&type=script&lang=js&"
export * from "./new_more.vue?vue&type=script&lang=js&"
import style0 from "./new_more.vue?vue&type=style&index=0&id=48921dda&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports